import { dedupe, ensureCCW, widthAt, type Pt } from "../math/polygon";

const TOL = 1e-6;
const r3 = (v: number): number => Math.round(v * 1000) / 1000;

/** Çokgenin iç yatay kenar kotları (taban ve tepe hariç, artan) — serbest çizimde derz tahkik kotları bunlardan türetilir. */
export function ledgeLevels(polygon: Pt[]): number[] {
  const ys = polygon.map((p) => p.y);
  const baseY = Math.min(...ys), yTop = Math.max(...ys);
  const out = new Set<number>();
  for (let i = 0; i < polygon.length; i++) {
    const a = polygon[i]!, b = polygon[(i + 1) % polygon.length]!;
    if (Math.abs(a.y - b.y) < TOL && a.y > baseY + TOL && a.y < yTop - TOL) out.add(Math.round(a.y * 1e6) / 1e6);
  }
  return [...out].sort((u, v) => u - v);
}

/**
 * Temel bloğu üst kotu sezgisi: en alttaki iç yatay kot ki kesit o kotun hemen üstünde HER İKİ yüzde de daralıyor
 * (burun ve topuk çıkıntısı). Yoksa undefined (temel bloğu yok).
 */
export function detectBodyBaseY(polygon: Pt[]): number | undefined {
  for (const y of ledgeLevels(polygon)) {
    const below = widthAt(polygon, y - 1e-4), above = widthAt(polygon, y + 1e-4);
    if (below && above && above.xMin > below.xMin + 1e-4 && above.xMax < below.xMax - 1e-4) return y;
  }
  return undefined;
}

/**
 * Serbest çizilen çokgeni motor sözleşmesine getirir: CCW, yinelenen noktalar atılmış, taban y = 0, burun (en alt-sol köşe) x = 0, 3 ondalık.
 * Geçerlilik denetimi yapmaz (`validatePolygon`).
 */
export function normalizePolygon(points: Pt[]): Pt[] {
  const p = ensureCCW(dedupe(points));
  if (p.length === 0) return p;
  const baseY = Math.min(...p.map((q) => q.y));
  const toeX = Math.min(...p.filter((q) => Math.abs(q.y - baseY) < TOL).map((q) => q.x));
  const shifted = p.map((q) => ({ x: r3(q.x - toeX), y: r3(q.y - baseY) }));
  const i0 = shifted.findIndex((q) => Math.abs(q.x) < TOL && Math.abs(q.y) < TOL);
  return i0 > 0 ? [...shifted.slice(i0), ...shifted.slice(0, i0)] : shifted;
}
